import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CardLockState {
  loading: boolean;
  status: string | null; // Keep this as a string if API returns just "LOCK" or "UNLOCK"
  error: string | null;
  updateSuccess: boolean;
}

const initialState: CardLockState = {
  loading: false,
  status: null,
  error: null,
  updateSuccess: false,
};

const cardLockSlice = createSlice({
  name: 'cardLock',
  initialState,
  reducers: {
    // Fetch card lock status
    fetchCardLockStatusRequest(
      state,
      action: PayloadAction<{ accountId: string; customerId: string }>
    ) {
      state.loading = true;
      state.error = null;
    },
    fetchCardLockStatusSuccess(state, action: PayloadAction<string>) {
      state.loading = false;
      state.status = action.payload; // Ensure payload is string ("LOCK" or "UNLOCK")
      state.error = null;
    },
    fetchCardLockStatusFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    // Update card lock status
    updateCardLockStatusRequest(
      state,
      action: PayloadAction<{
        accountId: string;
        customerId: string;
        status: boolean;
      }>
    ) {
      state.loading = true;
      state.updateSuccess = false;
      state.error = null;
    },
    updateCardLockStatusSuccess(state, action: PayloadAction<string>) {
      state.loading = false;
      state.status = action.payload;
      state.updateSuccess = true;
      state.error = null;
    },
    updateCardLockStatusFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.updateSuccess = false;
      state.error = action.payload;
    },
    resetCardLockSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  fetchCardLockStatusRequest,
  fetchCardLockStatusSuccess,
  fetchCardLockStatusFailure,
  updateCardLockStatusRequest,
  updateCardLockStatusSuccess,
  updateCardLockStatusFailure,
  resetCardLockSlice,
} = cardLockSlice.actions;

export default cardLockSlice.reducer;
